import moment from "moment";
import OfficialDiaryAppService from "../../../../application/platform/official-daily/official-daily-app-service";
import { IConfirmPublicationRequest } from "../../../../model/official-daily/request/confirm-publication-request";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import { ACTION_TYPES, usePublicacaoDiarioOficialDispatch, usePublicacaoDiarioOficialState } from "./publicacao-diario-oficial-context";
import { DefaultDialogProps } from "../../../components/default-dialog";
import { useNavigate, useParams } from "react-router-dom";
import { IPreviewPublicationRequest } from "../../../../model/official-daily/request/preview-publication-request";
import BaseAppService from "../../../../application/platform/official-daily/basa-app-service";
import PublicationShipmentAppService from "../../../../application/platform/publication-shipment/publication-shipment-app-service";
import { IUpdatePublicationShipmentRequest } from "../../../../model/publication-shipment/request/update-publication-shipment-request";

export const usePublicacaoDiarioOficialController = () => {
    const steps = ['Dados da Publicação', 'Visualizar Publicação'];
    const { showMessage, showBackDrop, showDialog } = useBaseLayoutController();
    const { publicationShipmentId } = useParams();
    const { activeStep, previewPublicationRequest, files, previewPublicationResponse, completed } = usePublicacaoDiarioOficialState();
    const publicacaoDiarioOficialDispatch = usePublicacaoDiarioOficialDispatch();
    const navigate = useNavigate();
    const totalSteps = () => {
        return steps.length;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const base64ToFile = (base64String: string, contentType: string, fileName: string) => {
        const arr = base64String.split(',');

        const bstr = atob(arr[1]); // Decodifica a parte Base64
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: contentType });

    };

    const drawPublicationShipmment = (publicationShipmentId: number) => {

        (async () => {
            showBackDrop(true);


            var filesDownload = await PublicationShipmentAppService.downloadFilesBase64(publicationShipmentId);

            // Filter files by PDF content type
            var pdfFilesDownload = filesDownload.filter(file => file.contentType === 'application/pdf');

            const files: File[] = [];

            for (let i = 0; i < pdfFilesDownload.length; i = i + 1) {
                var file = pdfFilesDownload[i];
                let fileObject = base64ToFile(file.source, file.contentType, file.name);
                files.push(fileObject);
            }

            if (filesDownload.length !== pdfFilesDownload.length) {
                showDialog({
                    open: true,
                    title: "Aviso",
                    type: "warning",
                    message: "Ao diagramar essa remessa, existem arquivos que não são PDFs e não serão incluidos na diagramação.",
                } as DefaultDialogProps);
            }


            var publicationShippment = await PublicationShipmentAppService.getById(publicationShipmentId);

            await PublicationShipmentAppService.update({ id: publicationShipmentId, statusId: 2 } as IUpdatePublicationShipmentRequest);

            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setPreviewPublicationRequest,
                payload: { ...previewPublicationRequest, description: publicationShippment.description, clientId: publicationShippment.personEntityId } as IPreviewPublicationRequest,
            });

            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setFiles,
                payload: files,
            });
            showBackDrop(false);
        })();

    };

    const handleTabFormChange = (event: any, newTabIndex: number) => {
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setTabIndexForm,
            payload: newTabIndex,
        });
    };

    const handleTabPreviewChange = (event: any, newTabIndex: number) => {
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setTabIndexPreview,
            payload: newTabIndex,
        });
    };
    const setFiles = (files: File[]) => {
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setFiles,
            payload: files,
        });
    }

    const getInit = () => {
        showBackDrop(true);
        (async () => {

            const data1 = await OfficialDiaryAppService.listCategories();
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setCategoryPublicationResponse,
                payload: data1,
            });
            const data2 = await OfficialDiaryAppService.listEntityPublication();
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setEntityPublicationResponse,
                payload: data2,
            });
            const data3 = await BaseAppService.listDocumentTypes();
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setListDocumentTypesResponse,
                payload: data3,
            });
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setFiles,
                payload: [] as File[],
            });

        })();

        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setActiveStep,
            payload: 0,
        });
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setTabIndexForm,
            payload: 0,
        });
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setTabIndexPreview,
            payload: 0,
        });
        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setPreviewPublicationRequest,
            payload: { republication: false, clientId: previewPublicationRequest.clientId, publicationDateOn: moment().format("YYYY-MM-DD"), description: "", descriptionCommission: "", notes: "", number: "" } as IPreviewPublicationRequest,
        });

        setFiles([]);
        showBackDrop(false);
    }

    const requestPreviewPublicationRequest = () => {
        (async () => {
            try {
                showBackDrop(true);
                const data = await OfficialDiaryAppService.previewPublication(previewPublicationRequest, files);
                publicacaoDiarioOficialDispatch({
                    type: ACTION_TYPES.setPreviewPublicationResponse,
                    payload: data,
                });
                publicacaoDiarioOficialDispatch({
                    type: ACTION_TYPES.setActiveStep,
                    payload: 1,
                });
                showBackDrop(false);
            } catch {
                console.error("Fail request");
            }
        })();
    }

    const requestConfirmPublicationRequest = () => {
        (async () => {

            let requestModel = Object.assign({} as IConfirmPublicationRequest, previewPublicationResponse);

            requestModel.submissionPublicationId = Number(publicationShipmentId);

            showBackDrop(true);

            await OfficialDiaryAppService.confirmPublication(requestModel);

            showBackDrop(false);

            showDialog({
                open: true,
                message: "Publicação salva com suceso. Deseja diagramar outra publicação?",
                onYesClick: () => {
                    navigate('/diagramar-diario-oficial');
                    getInit();
                }, onNoClick: () => {
                    navigate('/dashboard');
                },
            } as DefaultDialogProps);

        })().then();
    }

    const validFields = (): boolean => {
        let isValid = true;

        if (previewPublicationRequest.categoryId === undefined || previewPublicationRequest.categoryId === 0) {
            isValid = false;
        }
        if (previewPublicationRequest.subcategoryId === undefined || previewPublicationRequest.subcategoryId === 0) {
            isValid = false;
        }

        if (previewPublicationRequest.clientId === undefined || previewPublicationRequest.clientId === 0) {
            isValid = false;
        }

        if (previewPublicationRequest.documentTypeId === undefined || previewPublicationRequest.documentTypeId === 0) {
            isValid = false;
        }

        if (previewPublicationRequest.publicAgencyId === undefined || previewPublicationRequest.publicAgencyId === 0) {
            isValid = false;
        }

        if (previewPublicationRequest.description === undefined || previewPublicationRequest.description.length === 0) {
            isValid = false;
        }

        if (previewPublicationRequest.publicationDateOn === undefined || previewPublicationRequest.publicationDateOn.length === 0) {
            isValid = false;
        }

        return isValid;
    }

    const confirmPublication = () => {
        showDialog({
            open: true,
            message: "Deseja realmente finalizar essa publicação?",
            onYesClick: () => {
                requestConfirmPublicationRequest();
            }
        } as DefaultDialogProps);
    }

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        if (newActiveStep === 1) {
            if (validFields()) {
                if (files.length > 0) {
                    requestPreviewPublicationRequest();
                } else {
                    showMessage({ type: 'error', message: 'É necessário selecionar ao menos um arquivo.', open: true });
                }
            } else {
                showMessage({ type: 'error', message: 'É necessário preenhcer todos os campos obrigtórios.', open: true });
            }
        } else if (newActiveStep === 1) {
            requestPreviewPublicationRequest();
        }
    };

    const handleBack = () => {
        let previousStep = activeStep - 1;
        if (previousStep === 0) {
            (async () => {
                await OfficialDiaryAppService.releasePublication(previewPublicationRequest.clientId);
                publicacaoDiarioOficialDispatch({
                    type: ACTION_TYPES.setActiveStep,
                    payload: 0,
                });
            })();

        } else {
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setActiveStep,
                payload: previousStep,
            });
        }
    }
    const loadSubcategory = (id: number) => {
        (async () => {
            const data = await OfficialDiaryAppService.listSubcategories(id);
            publicacaoDiarioOficialDispatch({
                type: ACTION_TYPES.setSubCategoryPublicationResponse,
                payload: data,
            });
        })();
    }

    const handleOnChange = (e: any) => {

        let categoryId = previewPublicationRequest.categoryId;
        let subcategoryId = previewPublicationRequest.subcategoryId;
        let number = previewPublicationRequest.number;
        let descriptionCommission = previewPublicationRequest.descriptionCommission;
        let descriptionPresidentCommission = previewPublicationRequest.descriptionPresidentCommission;
        let description = previewPublicationRequest.description;
        let notes = previewPublicationRequest.notes;
        let sanctionDateOn = previewPublicationRequest.sanctionDateOn;
        let entityPublicationId = previewPublicationRequest.publicAgencyId;
        let documentTypeId = previewPublicationRequest.documentTypeId;
        let clientId = previewPublicationRequest.clientId;
        let republication = previewPublicationRequest.republication;
        if (e.target.name === "select-category") {
            loadSubcategory(e.target.value);
            categoryId = e.target.value;
            number = "";
            if (e.target.value === 3) {
                descriptionCommission = "Comissão Permanente de Licitação";
            } else {
                descriptionCommission = "";
                sanctionDateOn = undefined;
                descriptionPresidentCommission = "";
            }
        } else if (e.target.name === "select-subcategory") {
            subcategoryId = e.target.value;
        } else if (e.target.name === "input-number") {
            number = e.target.value;
        } else if (e.target.name === "input-description-comission") {
            descriptionCommission = e.target.value;
        } else if (e.target.name === "input-description-president-comission") {
            descriptionPresidentCommission = e.target.value;
        } else if (e.target.name === "input-description") {
            description = e.target.value;
        } else if (e.target.name === "input-notes") {
            notes = e.target.value;
        } else if (e.target.name === "select-entity-publication") {
            entityPublicationId = e.target.value;
        } else if (e.target.name === "select-client") {
            clientId = e.target.value;
        } else if (e.target.name === "select-dcoument-type") {
            documentTypeId = e.target.value;
        }
        else if (e.target.name === "switch-repubblication") {
            republication = e.target.checked;
        }

        publicacaoDiarioOficialDispatch({
            type: ACTION_TYPES.setPreviewPublicationRequest,
            payload: { ...previewPublicationRequest, description: description?.toUpperCase(), clientId, documentTypeId, categoryId, number, subcategoryId, descriptionPresidentCommission, descriptionCommission, sanctionDateOn, notes: notes?.toUpperCase(), publicAgencyId: entityPublicationId, republication },
        });
    }
    return {
        handleTabFormChange, setDataPublicationAndUpdate: drawPublicationShipmment, handleTabPreviewChange, getInit, loadSubcategory, handleOnChange, isLastStep, setFiles, handleBack, validFields, handleNext, steps, confirmPublication
    };
}